var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgConfirmacionClientePagadora(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 145 145",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#e0eefb;}.cls-2{fill:#e8b954;}.cls-3{fill:#4c74b6;}.cls-4{fill:#d2dde6;}.cls-5{fill:#adbccb;}.cls-6{fill:#fbf59d;}.cls-7{fill:#6baec9;}.cls-8{fill:#f3d585;}.cls-9{fill:#f7ef66;}.cls-10{fill:#c2fb3b;}.cls-11{fill:#9cdd05;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "confirmacion_clientes_pagadoras") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 72.5,
    cy: 72.5,
    r: 72.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M79.46,111.48l-16.9-.11,0-3.38,16.9.11a1.69,1.69,0,0,0,0-3.38l-16.9-.11,0-3.38,16.9.11a5.07,5.07,0,0,1-.07,10.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M35.45,121.32l.15-22,6.76,0-.15,22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M53.38,59.47l20.37.14-.35,51L53,110.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M73.68,69.8l20.38.14-.28,40.76-20.38-.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M65.23,64.65l3.39,0,0,3.4-3.4,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M58.43,64.6l3.4,0,0,3.4-3.4,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M65.18,71.44l3.4,0,0,3.4-3.39,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M58.39,71.39l3.39,0,0,3.4-3.4,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M65.13,78.23l3.4,0,0,3.4-3.39,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M58.34,78.18l3.4,0,0,3.39-3.39,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M65.08,85l3.4,0,0,3.39-3.4,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M58.29,85l3.4,0,0,3.4-3.39,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M65,91.82l3.39,0,0,3.4-3.4,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M58.24,91.77l3.4,0,0,3.4-3.4,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M65,98.61l3.4,0,0,3.4L65,102Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M58.2,98.56l3.39,0,0,3.4-3.4,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M85.53,75l3.4,0,0,3.4-3.4,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M78.74,74.93l3.4,0,0,3.4-3.39,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M85.49,81.77l3.39,0,0,3.4-3.4,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M78.69,81.72l3.4,0,0,3.39-3.4,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M85.44,88.56l3.4,0,0,3.39-3.39,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M78.65,88.51l3.39,0,0,3.39-3.4,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M85.39,95.36l3.4,0,0,3.4-3.39,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M78.6,95.31l3.39,0,0,3.4-3.4,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M85.34,102.15l3.4,0,0,3.4-3.4,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M78.55,102.1l3.4,0,0,3.4-3.39,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M27,117.88l.11-15.21,8.45.06-.11,15.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M108.26,101.55a4.13,4.13,0,0,1-2,5.2L76,121.6,42.23,118l.11-15.21,37.18.26a3.38,3.38,0,0,1,3.35,3.41l18.64-6.63C104.9,98.14,107.29,99.08,108.26,101.55Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 50.92,
    cy: 40.3,
    r: 16.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M52.69,28.48l-3.38,0,0,3.38-3.38,0a1.7,1.7,0,0,0-1.71,1.68l0,6.76A1.67,1.67,0,0,0,45.83,42l8.45.06,0,3.38-10.14-.07,0,3.38,5.07,0,0,3.38,3.38,0,0-3.38,3.38,0a1.7,1.7,0,0,0,1.7-1.68l0-6.76A1.69,1.69,0,0,0,56,38.65l-8.45-.06,0-3.38,10.14.07,0-3.38-5.07,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M117.52,31.07,113,26.5a1.61,1.61,0,0,0-2.27,0l-10.45,10.3-5.87,5.79L89.91,38a1.59,1.59,0,0,0-1.13-.47,1.56,1.56,0,0,0-1.14.46L83.07,42.5a1.61,1.61,0,0,0,0,2.27L93.2,55.05a1.6,1.6,0,0,0,1.13.48,1.64,1.64,0,0,0,1.14-.46l4.73-4.67,17.3-17.06a1.61,1.61,0,0,0,0-2.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M93.2,55.05a1.6,1.6,0,0,0,1.13.48,1.64,1.64,0,0,0,1.14-.46l4.73-4.67.09-13.62-5.87,5.79L89.91,38a1.59,1.59,0,0,0-1.13-.47,1.56,1.56,0,0,0-1.14.46L83.07,42.5a1.61,1.61,0,0,0,0,2.27Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfirmacionClientePagadora);
export default __webpack_public_path__ + "static/media/confirmacion_cliente_pagadora.97a3b4809cdc150cc5c320527699adcd.svg";
export { ForwardRef as ReactComponent };